<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/zk15Vs/tc-custom/9780253006530.jpg?1726617359195" alt="This image is the cover for the book Beauty Unlimited"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Beauty Unlimited
      </h1>
      <p class="bookDescription body article font2">
        <b>“A feminist aesthetics text which bridges aesthetic theory, art and popular culture and acknowledges the evolving character of standards of beauty” (</b><b><i>Teaching Philosophy</i></b><b>).</b><br/>  <br/> Emphasizing the human body in all of its forms, <i>Beauty Unlimited</i> expands the boundaries of what is meant by beauty, both geographically and aesthetically. Peg Zeglin Brand and an international group of contributors interrogate the body and the meaning of physical beauty in this multidisciplinary volume.<br/>  <br/> This striking and provocative book explores the history of bodily beautification; the physicality of socially or culturally determined choices of beautification; the interplay of gender, race, class, age, sexuality, and ethnicity within and on the body; and the aesthetic meaning of the concept of beauty in an increasingly globalized world.
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Peg Zeglin Brand, Carolyn Korsmeyer, Gregory Velazco Trianosky, Noël Carroll
      </h2>
      
      <p class="authorDescription body article">Peg Zeglin Brand is an artist, Adjunct Associate Professor of Philosophy at IUPUI (Indiana University Purdue University–Indianapolis), and Adjunct Instructor in the University of Oregon School of Law Appropriate Dispute Resolution Center and the UO Robert D. Clark Honors College. She is the author of numerous articles in feminist philosophy and aesthetics as well as the editor of Beauty Matters (IUP, 2000) and co-editor with Carolyn Korsmeyer of Feminism and Tradition in Aesthetics.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Indiana University Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?46de45fa